/**
 * Loads the current session once on mount. Re-checked only via reload (sign-in
 * and sign-out trigger a full navigation/reload, so we don't poll).
 */
import { useAsync } from '../hooks/useAsync';
import { getSession } from './authClient';
import type { SessionUser } from './types';

export interface SessionState {
  user: SessionUser | null | undefined;
  loading: boolean;
  error: Error | null;
}

export function useSession(): SessionState {
  const { data, loading, error } = useAsync<SessionUser | null>(
    () => getSession(),
    [],
  );
  return { user: data, loading, error };
}
